<template>
  <section class="w-full mx-auto mb-2 px-2 font-sans print:hidden">
    <ol class="relative">
      <li
        class="mb-4 max-sm:snap-mt-[80px] max-sm:snap-mb-[500px] sm:scroll-mt-[120px] sm:scroll-mb-[300px] break-inside-avoid"
      >
        <section
          name="card"
          class="relative flex flex-col sm:flex-row bg-white rounded-lg shadow-lg animate-pulse"
        >
          <figure class="relative flex flex-col justify-center sm:order-last">
            <SvgImagePlaceholder
              class="w-full object-cover rounded-t-lg p-2 sm:w-[30rem] sm:h-72 sm:m-2 sm:rounded-lg fill-green-400"
              alt="Placeholder"
            />
          </figure>
          <section
            name="content"
            class="relative flex flex-col flex-1 px-2 pt-4"
          >
            <div class="my-2 h-6 w-[30%] bg-blue-gray-400 rounded-xs" />
            <div class="my-2 h-5 w-[80%] bg-blue-gray-400 rounded-xs" />
            <div class="my-2 h-5 w-[76%] bg-blue-gray-400 rounded-xs" />
            <div class="my-2 h-5 w-[83%] bg-blue-gray-400 rounded-xs" />
          </section>
        </section>
      </li>
    </ol>
  </section>
</template>
